import * as Icons from "lucide-react";

export function DynIcon({ name, className = "", strokeWidth = 1.5 }) {
  const Cmp = Icons[name] || Icons.Zap;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
}
